import angular from 'angular';

import { HijackUserController } from './hijack-user.view/hijack-user';
import { UserService } from './service.tn.user';

export default angular
    .module('tn.user', ['tn.utils', 'tn.django'])
    // components
    .controller('tnHijackUser', HijackUserController)
    // providers
    .service('tn.user.service', UserService).name;
